export enum DBColumnDataType {
    STRING= 'string',
    NUMBER = 'number',
    DATE = 'date',
}
